import React, { useCallback, useContext, useEffect, useState } from "react";
import styled from "styled-components";

import { Button } from "@/components/Form";
import ResultGlass, { ResultType, SharingType } from "@/components/ResultGlass";
import { GlobalContext } from "@/contexts";
import LocaleContext from "@/i18n";
import { handleShare } from "@/utils/socialActions";

type PollSummaryProps = {
  icons: IIcons;
  userVoteCount: number;
  totalVoteCount: number;
  showDetails: boolean;
  sharingTitle: string;
  onCtaClick?: () => void;
  onLoad?: () => void;
};

export const PollSummary: React.FC<PollSummaryProps> = (
  props: PollSummaryProps
): JSX.Element => {
  const [showResult, setShowResult] = useState<boolean>(false);

  const globalContext = useContext(GlobalContext);
  const localeContext = useContext(LocaleContext);

  const {
    onCtaClick,
    sharingTitle,
    icons,
    userVoteCount,
    totalVoteCount,
    showDetails,
    onLoad,
  } = props;

  useEffect(() => {
    if (onLoad) {
      setTimeout(() => onLoad(), 4500);
    }
    setTimeout(() => setShowResult(true), 1500);
  }, []);

  const handleShareClick = useCallback((type: SharingType) => {
    handleShare(type, sharingTitle, globalContext.brand?.twitterHandle);
  }, []);

  return (
    <SummaryContent>
      {showResult && (
        <SummaryBox>
          <ResultGlass
            type={ResultType.percent}
            resultText={localeContext.translation.pollSummary.resultText}
            onShareClick={handleShareClick}
            icons={icons}
            userVoteCount={userVoteCount}
            totalVoteCount={totalVoteCount}
            showDetails={showDetails}
          />
        </SummaryBox>
      )}
      {showResult && onCtaClick && (
        <Button onClick={onCtaClick}>
          {localeContext.translation.registerAgain}
        </Button>
      )}
    </SummaryContent>
  );
};

const SummaryContent = styled.div`
  min-height: 361px;
  width: 90%;
  margin: 0 auto;
`;

const SummaryBox = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;
